import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options) => {
  const response = await api.get("kam/files", options);

  return response;
};

export const get = async (id) => {
  const response = await api.get(`kam/files/${id}`, {
    responseType: "blob",
  });

  return response;
};

export const post = async (
  file,
  {
    headers: {
      "Content-Type": contentType = "multipart/form-data",
      ...restHeaders
    } = {},
    params: { showMessage = true, ...restParams } = {},
    ...restOptions
  } = {},
) => {
  const response = await api.post("kam/files", file, {
    headers: { "Content-Type": contentType, ...restHeaders },
    params: { showMessage, ...restParams },
    ...restOptions,
  });

  return response;
};

export const postOnboarding = async (
  file,
  {
    headers: {
      "Content-Type": contentType = "multipart/form-data",
      ...restHeaders
    } = {},
    params: { showMessage = true, PII = 1, ...restParams } = {},
    ...restOptions
  } = {},
) => {
  const response = await api.post(`/kam/user/${file.user_id}/files`, file, {
    headers: { "Content-Type": contentType, ...restHeaders },
    params: { showMessage, PII, ...restParams },
    ...restOptions,
  });

  return response;
};

export const put = async (file) => {
  const response = await api.put("kam/files", file, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
};

export const remove = async (_id, payload) => {
  const response = await api.put(`kam/file/${_id}`, payload);

  return response;
};

export const removeOnboarding = async (_id, payload) => {
  const response = await api.put(`/kam/user/files/${_id}/remove`, payload);

  return response;
};

export const restore = async (_id, payload) => {
  const response = await api.put(`kam/file/restore/${_id}`, payload);

  return response;
};
